import Service from "../Service";
const resource = "LgsQuotation/";

export default {
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID },
        });
    },
    byID(parameters, requestID) {
        return Service.post(resource + "byid", parameters, {
            params: { requestID: requestID },
        });
    },
    getEmailSupplier(SupCode, requestID) {
        return Service.post(
            resource + "getEmailSupplier", {}, {
                params: { SupCode: SupCode, requestID: requestID },
            }
        );
    },
    getUser(ruc, requestID) {
        return Service.post(resource + "getUser", {}, {
            params: { ruc: ruc, requestID: requestID },
        });
    },
    inviteSupplier(usr, requestID) {
        return Service.post(resource + "inviteSupplier", usr, {
            params: { requestID: requestID },
        });
    },
};